/**
 * What We Offer page
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React from 'react'
import Layout from 'components/Layout'
import { graphql, useStaticQuery } from 'gatsby'

const HowCourseraWorks = (props) => {
  const data = useStaticQuery(graphql`
    query {
      contentfulPage(slug: { eq: "how-coursera-works" } siteId: {eq: "About"}) {
        ...PageFragment
      }
    }
  `)

  const wwoPage = data?.contentfulPage || {}

  return (
    <Layout {...props} {...wwoPage} />
  )
}

export default HowCourseraWorks
